<template>
  <div>
    <mdb-modal size="sm" centered :show="visible">
      <mdb-modal-body class="d-flex flex-center">
          <mdb-spinner big color="yellow" />
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalBody, mdbSpinner} from 'mdbvue';

  export default {
    components: {
      mdbModal,
      mdbModalBody,
      mdbSpinner
    },
    props: ['visible']
  };
</script>